// Lightweight silent mentor service: templates, variant selection, and nudge generation
const VARIANTS = ['control', 'variantA', 'variantB'];

function pickStoredVariant() {
  try {
    if (typeof window === 'undefined') return 'control';
    const v = window.localStorage.getItem('silent_mentor_variant');
    if (v && VARIANTS.includes(v)) return v;
    // Assign a variant: 50% control, 30% variantA, 20% variantB
    const r = Math.random();
    const assigned = r < 0.5 ? 'control' : r < 0.8 ? 'variantA' : 'variantB';
    window.localStorage.setItem('silent_mentor_variant', assigned);
    return assigned;
  } catch (e) {
    return 'control';
  }
}

const TEMPLATES = {
  control: [
    {
      id: 'improve_simple',
      title: 'Quick progress update',
      message: ({ score, total }) => `You scored ${score} / ${total}. Keep the streak going.`,
      action: () => 'Practice 10 Qs',
    },
    {
      id: 'strengths_weakness_simple',
      title: 'Quick progress update',
      message: ({ best, worst }) =>
        best && worst
          ? `Strongest: ${best.topic} (${Math.round(best.accuracy * 100)}%). Weakest: ${worst.topic} (${Math.round(
              worst.accuracy * 100,
            )}%).`
          : 'Nice attempt — keep practicing!',
      action: ({ worst }) => (worst ? `Practice ${worst.topic} — 10 Qs` : 'Practice 10 Qs'),
    },
  ],
  variantA: [
    {
      id: 'improve_delta',
      title: 'Progress snapshot',
      message: ({ delta, best, worst, score, total }) => {
        if (delta && Math.abs(delta) >= 1) return `Your accuracy changed ${delta > 0 ? '↑' : '↓'}${Math.abs(delta)}% this week.`;
        if (best && worst)
          return `Top skill: ${best.topic} (${Math.round(best.accuracy * 100)}%). Work on ${worst.topic}.`;
        return `You scored ${score}/${total}. Small steps add up.`;
      },
      action: ({ worst }) => (worst ? `Practice ${worst.topic}` : 'Practice now'),
    },
  ],
  variantB: [
    {
      id: 'benchmark_social',
      title: 'How you compare',
      message: ({ score, total }) => `Most toppers attempt 2 mocks/day at this stage. You scored ${score}/${total}.`,
      action: () => 'See topper routines',
    },
  ],
};

export function getVariant() {
  return pickStoredVariant();
}

export function generateNudge({ score, total, topics = [] , delta = null, examId = 'unknown' } = {}) {
  const variant = getVariant();
  const templates = TEMPLATES[variant] || TEMPLATES.control;

  // Compute best/worst topic if available
  const eligible = topics.filter(t => t.total >= 2);
  const best = eligible.slice().sort((a, b) => b.accuracy - a.accuracy)[0];
  const worst = eligible.slice().sort((a, b) => a.accuracy - b.accuracy)[0];

  const context = { score, total, topics, best, worst, delta };

  // Simple selection: prefer strength/weakness template if best/worst present
  let chosen = templates[0];
  if (best && worst) {
    const found = templates.find(t => /strength|weakness|strengths_weakness_simple|improve/.test(t.id));
    if (found) chosen = found;
  }

  const message = typeof chosen.message === 'function' ? chosen.message(context) : chosen.message;
  const actionLabel = typeof chosen.action === 'function' ? chosen.action(context) : chosen.action;

  return {
    nudgeId: `silent_${examId}_${chosen.id}`,
    title: chosen.title || 'Update',
    message,
    actionLabel,
    variant,
  };
}

export default { getVariant, generateNudge };
